import React from 'react';
import MediaQuery from 'react-responsive';
import { AddressProps } from '../common/types';
import { WrapperStoreData } from '../common/WrapperStoreData';
import { SummaryDesktop } from './components/ShopDataSummaryDesktop';
import { SummaryMobile } from './components/ShopDataSummaryMobile';

interface OptionsAddress {
  bgColor: string;
  urlImg: string;
  nameStore: string;
  phone: string;
  address: AddressProps;
  s3: string;
  id: number;
  type: string;
}
interface Props {
  dataAddress: OptionsAddress;
  dataValue?: string;
  telephoneAsLink?: boolean;
}

export const SummaryShopData = ({ dataAddress, dataValue, telephoneAsLink }: Props) => {
  if (!dataAddress) {
    return null;
  }
  return (
    <WrapperStoreData type="summary">
      <MediaQuery maxWidth={767}>
        <SummaryMobile
          telephoneAsLink={telephoneAsLink}
          dataStore={dataAddress}
          dataValue={dataValue}
        />
      </MediaQuery>
      <MediaQuery minWidth={768}>
        <SummaryDesktop
          telephoneAsLink={telephoneAsLink}
          dataStore={dataAddress}
          dataValue={dataValue}
        />
      </MediaQuery>
    </WrapperStoreData>
  );
};
